<template>
    <div class="templateFour" v-if="data.cardImgIcon">
        <!-- <div class="container"> -->
            <div class="mainContents mx-auto">
                <!-- {{ this.data.cardData._id }}
                {{ this.user_id }} -->
                <section class="vcard__banner w-100 position-relative">
                    <!-- <img src="https://www.karti.io/uploads/vcards/covers/1750/WhatsApp-Image-2022-08-15-at-1.22.51-PM.jpeg" class="img-fluid banner-image" alt="banner"> -->
                    <img :src="imgUrl + '/' + data.cardImgIcon.backgroundImg" class="img-fluid banner-image" alt="banner" v-if="data.cardImgIcon.backgroundImg != ''">
                </section>

                <section class="vcard__profile d-flex align-items-center px-4 flex-sm-row flex-column">
                    <div class="vcard__avatar">
                        <!-- <img src="https://www.karti.io/uploads/vcards/profiles/1749/WhatsApp-Image-2022-08-15-at-1.22.53-PM.jpeg" class="rounded-circle"> -->
                        <img :src="imgUrl + '/' + data.cardImgIcon.profileImg" class="rounded-circle" v-if="data.cardImgIcon.profileImg != ''">
                    </div>
                    <div class="vcard__position d-flex flex-column mx-sm-4 mt-sm-5 mt-2">
                        <div class="vcard_details d-flex flex-column">
                            <h4 class="avatar-name text-sm-start text-center">{{ data.cardData.details.firstName }} {{ data.cardData.details.lastName }}</h4>
                            <span class="avatar-designation text-sm-start text-center">{{ data.cardData.details.jobTitle }}</span>
                        </div>
                        <div class="vcard__social">
                            <span v-if="data.cardData.socialMedia.siteWeb && data.cardData.socialMedia.siteWeb != ''" @click="reddirectTo(data.cardData.socialMedia.siteWeb)"><i class="fa-solid fa-globe"></i></span>
                            <span v-if="data.cardData.socialMedia.twitter && data.cardData.socialMedia.twitter != ''" @click="reddirectTo(data.cardData.socialMedia.twitter)"><i class="fa-brands fa-twitter"></i></span>
                            <span v-if="data.cardData.socialMedia.facebook && data.cardData.socialMedia.facebook != ''" @click="reddirectTo(data.cardData.socialMedia.facebook)"><i class="fa-brands fa-facebook-f"></i></span>
                            <span v-if="data.cardData.socialMedia.instagram && data.cardData.socialMedia.instagram != ''" @click="reddirectTo(data.cardData.socialMedia.instagram)"><i class="fa-brands fa-instagram"></i></span>
                            <span v-if="data.cardData.socialMedia.reddit && data.cardData.socialMedia.reddit != ''" @click="reddirectTo(data.cardData.socialMedia.reddit)"><i class="fa-brands fa-reddit"></i></span>
                            <span v-if="data.cardData.socialMedia.tumblr && data.cardData.socialMedia.tumblr != ''" @click="reddirectTo(data.cardData.socialMedia.tumblr)"><i class="fa-brands fa-tumblr"></i></span>
                            <span v-if="data.cardData.socialMedia.youtube && data.cardData.socialMedia.youtube != ''" @click="reddirectTo(data.cardData.socialMedia.youtube)"><i class="fa-brands fa-youtube"></i></span>
                            <span v-if="data.cardData.socialMedia.linkdin && data.cardData.socialMedia.linkdin != ''" @click="reddirectTo(data.cardData.socialMedia.linkdin)"><i class="fa-brands fa-linkedin-in"></i></span>
                            <span v-if="data.cardData.socialMedia.whathsapp && data.cardData.socialMedia.whathsapp != ''" @click="reddirectTo('https://wa.me/'+data.cardData.socialMedia.whathsapp)"><i class="fa-brands fa-whatsapp"></i></span>
                            <span v-if="data.cardData.socialMedia.pinterest && data.cardData.socialMedia.pinterest != ''" @click="reddirectTo(data.cardData.socialMedia.pinterest)"><i class="fa-brands fa-pinterest"></i></span>
                            <span v-if="data.cardData.socialMedia.tiktok && data.cardData.socialMedia.tiktok != ''" @click="reddirectTo(data.cardData.socialMedia.tiktok)"><i class="fa-brands fa-tiktok"></i></span>
                            <span v-if="data.cardData.socialMedia.telegram && data.cardData.socialMedia.telegram != ''" @click="reddirectTo(data.cardData.socialMedia.telegram)"><i class="fa-brands fa-telegram"></i></span>
                        </div>
                    </div>
                </section>

                <section class="profile_description">
                    <h4>{{ data.cardData.details.company }}</h4>
                    <p>{{ data.cardData.description }}</p>
                </section>

                <section class="vcard__general_info px-4 my-3">
                    <div class="contents">
                        <div class="card" v-if="data.cardData.details.email != ''">
                            <i class="fa-solid fa-envelope"></i>
                            <a :href="'mailto:'+data.cardData.details.email">{{ data.cardData.details.email }}</a>
                        </div>

                        <div class="card" v-if="data.cardData.details.birthdayDay != ''">
                            <i class="fa-solid fa-cake-candles"></i>
                            <a href="#">{{ data.cardData.details.birthdayDay }}</a>
                        </div>
 
                        <div class="card" v-if="data.cardData.details.phone != ''">
                            <i class="fa-solid fa-phone"></i>
                            <a :href="'tel:'+data.cardData.details.phone">{{ data.cardData.details.phone }}</a>
                        </div>

                        <div class="card" v-if="data.cardData.details.place != ''">
                            <i class="fa-solid fa-location-dot"></i>
                            <a :href="data.cardData.details.placeUrl.url">{{ data.cardData.details.place }}</a>
                        </div>
                    </div>
                </section>

                <section class="vcard__services" v-if="data.cardService.length != 0">
                    <h4> {{ data.cardData.details.defaultLanguage == "English" ? "Services": "خدمتنا" }} </h4>

                    <div class="services d-flex align-items-center">
                        <router-link :to="'/S/services/' + $route.params.smartCardID">
                             <button type="button" class="btn btn-secondary vcard__banner_view_more_btn">Services list</button>
                        </router-link>
                    </div>
                </section>

                <section class="vcard__products" v-if="data.cardProduct.length != 0">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Products": "منتجات" }}</h4>

                    <div class="services d-flex align-items-center">
                        <router-link :to="'/S/products/' + $route.params.smartCardID">
                             <button type="button" class="btn btn-secondary vcard__banner_view_more_btn">Products list</button>
                        </router-link>
                    </div>
                </section>

                <!-- <section class="vcard__services" v-if="data.cardTemoin.length != 0">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Temoin": "التوصيات" }}</h4>

                    <div class="services">
                        <div class="service" v-for="(service, index) in data.cardTemoin" :key="index">
                            <div class="service_icon">
                                <img :src="imgUrl + '/' + service.testimonyImage" class="rounded-circle" v-if="service.testimonyImage && service.testimonyImage != ''">
                            </div>
                            <div class="service_name">
                                <p>{{ service.name }}</p>
                            </div>
                            <div class="service_description">
                                <p>{{ service.description }}</p>
                            </div>
                        </div>
                    </div>
                </section> -->

                <section class="vcard__qr_code">
                <h3 class="title_qr_code">QR Code</h3>
                    <div class="boxShadow">
                        <div class="contents">
                        <div class="contentimg">
                                <img :src="imgUrl + '/' + data.cardImgIcon.profileImg" class="rounded-circle">
                            </div>
                            <div class="content">
                                <qrcode-vue :value="value" :size="size" level="H" />
                            </div>
                            
                        </div>
                    </div>
                </section>

                <section class="vcard__working_hours px-4 my-3">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Working hours": "ساعات العمل" }}</h4>
                    <div class="contents">
                        <p v-if="data.cardData.workingHours.Monday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Monday": "الإثنين" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Monday.from }} - {{ data.cardData.workingHours.Monday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Tuesday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Tuesday": "الثلاثاء" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Tuesday.from }} - {{ data.cardData.workingHours.Tuesday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Wednesday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Wednesday": "الأربعاء" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Wednesday.from }} - {{ data.cardData.workingHours.Wednesday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Thursday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Thursday": "الخميس" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Thursday.from }} - {{ data.cardData.workingHours.Thursday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Friday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Friday": "الجمعة" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Friday.from }} - {{ data.cardData.workingHours.Friday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Saturday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Saturday": "السبت" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Saturday.from }} - {{ data.cardData.workingHours.Saturday.to }}</span>
                        </p>
                        <p v-if="data.cardData.workingHours.Sunday.working">
                            <span class="day">{{ data.cardData.details.defaultLanguage == "English" ? "Sunday": "الأحد" }}</span>
                            <span class="dot">:</span>
                            <span class="hour">{{ data.cardData.workingHours.Sunday.from }} - {{ data.cardData.workingHours.Sunday.to }}</span>
                        </p>
                    </div>
                </section>

                <section class="vcard__catalogue" v-if="data.cardCatalogue.length != 0">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Catalogues": "كتالوجات" }}</h4>
                    <div class="catalgueListBtn">
                        <!-- {{ $route.params.smartCardID }} -->
                        <router-link :to="'/S/catalogues/' + $route.params.smartCardID">
                             <button type="button" class="btn btn-secondary vcard__banner_view_more_btn">Catalogues list</button>
                        </router-link>
                    </div>
                </section>

                <section class="vcard__contact px-4 my-3">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Contact": "استفسارات" }}</h4>
                    <form class="formContents">
                        <div class="form-group">
                            <div>
                                <input type="text" v-model="name" class="form-control" :placeholder="data.cardData.details.defaultLanguage == 'English' ? 'name': 'اسمك'">
                            </div>
                        </div>
                        <div class="form-group">
                            <div>
                                <input type="text" v-model="email" class="form-control" :placeholder="data.cardData.details.defaultLanguage == 'English' ? 'Email': 'عنوان بريد الكتروني'">
                            </div>
                        </div>
                        <div class="form-group">
                            <div>
                                <input type="text" v-model="phone" class="form-control" :placeholder="data.cardData.details.defaultLanguage == 'English' ? 'Phone': 'أدخل الهاتف'">
                            </div>
                        </div>
                        <div class="form-group">
                            <div>
                                <!-- <input type="text" class="form-control" :placeholder="data.cardData.details.defaultLanguage == 'English' ? 'Type your message': 'اكتب رسالة هنا ...'"> -->
                                <textarea type="text" v-model="message" class="form-control" :placeholder="data.cardData.details.defaultLanguage == 'English' ? 'Type your message': 'اكتب رسالة هنا ...'" rows="5"></textarea>
                            </div>
                        </div>

                        <div class="btnList">
                            <button type="button" class="btn btn-light me-2" @click="sendMessage">{{ data.cardData.details.defaultLanguage == "English" ? "Send message": "أرسل رسالة" }}</button>
                            <button type="button" class="btn btn-light me-2" @click="addContact">{{ data.cardData.details.defaultLanguage == "English" ? "Add contact": "إضافة لقائمة المتصلين" }}</button>
                        </div>
                    </form>
                </section>

                <section class="copyright">
                    <span class="line"></span>
                    <p>Copyright &copy; {{ new Date().getFullYear() }} istpacket. All Rights Reserved</p>
                </section>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
import axios from 'axios'
import APIs from '../../../../../config'
import QrcodeVue from 'qrcode.vue' 

export default {
    data() {
        return {
            data: "",
            imgUrl: APIs.API_IMAGES,
            value: 'https://app.smartcard.womi.ma/S/'+this.$route.params.smartCardID,
            size: 150,
            user_id: localStorage.getItem('admin_id'),
            name: "",
            email: "",
            phone: "",
            message: "",
            idtemplate : "",
        }
    },
    async created() {
        await this.getCardCurrentData()
        // console.log("created", this.data._id)
        // console.log("created", this.user_id)
    },
    methods: {
        sendMessage() {
                const fd = {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    message: this.message
                }

                axios.post(`${APIs.API_URL}/contact/${this.data.cardData._id}/${this.user_id}`, fd)
                .then(() => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Added",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }).then(() => {
                    this.resetForm()
                })
                .catch( (error) => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
        },
        resetForm() {
            this.name = ""
            this.email = ""
            this.phone = ""
            this.message = ""
        },
        reddirectTo(url) {
            if(/^(http[s]?:\/\/)/.test(url)) {
                window.open(url, '_blank');
            }
            else {
                window.open("https://" + url, '_blank');
            }
        },
       async getCardCurrentData() {
        // Afficher l'alerte de chargement
            this.$swal.fire({
                title: 'Loading..',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                this.$swal.showLoading();
                }
          });
          try{
                const res =  await  axios.get(`${APIs.API_URL}/card/smartCard/${this.$route.params.smartCardID}`)
                this.data = res.data
                const idtemplate = this.data.cardData.IdfromTemplate
                console.log("data id = ",idtemplate);
                // methode to get idtemplate :
                this.emitIdTemplate(idtemplate) 
                // annuler l'alert de chargement :
                this.$swal.close();
          }catch(err){
                console.error("Une erreur s'est produite lors du chargement des données :", err);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'Une erreur s\'est produite lors du chargement des données. Veuillez réessayer plus tard.',
                    });
                  }
         
        },
        catalogueRedirection(url) {
            window.open(APIs.API_IMAGES + '/' + url, '_blank');
        },
        addContact() {
            let formData = {
                FN: this.data.cardData.details.firstName,
                LN: this.data.cardData.details.lastName,
                Org: this.data.cardData.details.company,
                Phone: this.data.cardData.details.phone,
                Title: this.data.cardData.details.jobTitle,
                Url: `https://app.smartcard.womi.ma/S/${this.$route.params.smartCardID}`,
                Notes: this.data.cardData.description,
            }
            axios.post(`${APIs.API_URL}/card/vcf/${this.$route.params.smartCardID}`, formData)
            .then(res => {
                window.open(`${APIs.API_IMAGES}/${res.data}`, "_blank")
            })
        },
        emitIdTemplate(idtemplate){
                this.$emit('idtemplatechanged',idtemplate)
                console.log("Emitting idTemplate 1:", idtemplate);
        }
    },
    components: {
      QrcodeVue,
    },
}
</script>

<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Shrikhand&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    $main_color: #D15286;
    $main_font: 'Poppins', sans-serif;
    $number_font: 'Shrikhand', cursive;

    .templateFour {
        font-family: $main_font;
        .mainContents {
            background-color: #fff;
            max-width: 576px;
            min-height: 100vh;

            @mixin card_products_services($category) {
                border: 1px solid transparent;
                border-radius: 0px 0px 20px 20px;
                padding: 5% 10% 10%;
               @if $category == service {
                    background: linear-gradient(to right, #BC498E, #EB5E7B);
               }
                @if $category == product {
                    margin: 5% 0%;
                    background: linear-gradient(to right, #EB5E7B, #BC498E);
                }
                @media (max-width: "576px") {
                    padding: 15% 5%;
                }
                h4 {
                    text-align: center;
                    font-size: 40px;
                    font-weight: bold;
                    box-shadow: 0px 15px 12px 0px gainsboro;
                    border-radius: 20px 0px 20px 0px;
                    color: white;
                }
                .services {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    .service {
                        width: 100%;
                        border: 0px solid gainsboro;
                        padding: 5% 2%;
                        margin-top: 25%;
                        box-shadow: 0px 4px 10px 3px gainsboro;
                        background-color: white;
                        @if $category == service {
                            border-radius: 20px;
                        }
                        @if $category == product {
                            border-radius: 20px;
                        }
                        .service_icon {
                            display: flex;
                            justify-content: center;
                            margin-top: -20%;
                            img {
                                width: 120px;
                                height: 120px;
                                object-fit: fill;
                                border: 5px solid white;
                            }
                        }
                        .service_name {
                            p {
                                text-align: center;
                                font-weight: bold;
                                font-size: 20px;
                                text-transform: uppercase;
                                color: $main_color;
                                padding: 0% 5%;
                                word-break: break-all;
                            }
                        }
                        .service_description {
                            p {
                                text-align: justify;
                                color: black;
                                font-weight: 400;
                                word-break: break-word;
                            }
                        }
                    }
                }
            }

            .vcard__banner_view_more_btn {
                width: 100%;
                font-size: 18px;
                background: white;
                color: black;
                font-weight: 500;
            }
            .vcard__banner {
                height: 200px;
                .img-fluid {
                    width: 100%;
                    height: 300px;
                    object-fit: cover;
                }
                img: {
                    object-fit: cover;
                }
            }
            .vcard__profile {
                margin-top: 5%;
                .vcard__avatar {
                    z-index: 10;
                    width: 40%;
                    @media (max-width: "576px") {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                    }
                    img {
                        border: 5px solid #fff;
                        height: 200px;
                        min-width: 200px;
                        -o-object-fit: cover;
                        object-fit: cover;
                        width: 200px;
                    }
                }
                .vcard__position {
                    width: 60%;
                    @media (max-width: "576px") {
                        width: 100%;
                    }
                    .vcard_details {
                        margin-top: 40px;
                        .avatar-name {
                            color: black;
                            font-size: 22px;
                            font-weight: bold;
                        }
                        .avatar-designation {
                            color: #505050;
                            font-size: 18px;
                            font-weight: 600;
                        }
                    }
                    .vcard__social {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        span {
                            color: white;
                            margin-right: 4%;
                            padding: 5px 7px 4px;
                            border: 1px solid #EB5E7B;
                            border-radius: 50%;
                            margin-bottom: 1%;
                            transition: all .3s ease-in-out;
                            cursor: pointer;
                            background:linear-gradient(to right, #EB5E7B, #BC498E);
                            @media (max-width: "576px") {
                                padding: 6px 9px 5px 10px;
                            }
                            &:hover {
                                background:linear-gradient(to right, #BC498E, #EB5E7B);
                                color: white;
                                border-color: $main_color;
                            }
                            i {
                                font-size: 20px;
                                width: 20px;
                                height: 20px;
                                @media (max-width: "576px") {
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }
            }
            .profile_description {
                margin-top: 3%;
                h4 {
                   // text-align: left;
                    padding: 0% 5%;
                    text-transform: uppercase;
                    font-size: 35px;
                    font-weight: 600;
                    text-align: center;
                    background:linear-gradient(to right, #EB5E7B, #BC498E);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                p {
                    text-align: left;
                    padding: 0% 5%;
                    text-align: center;
                }
            }
            .vcard__general_info {
                .contents {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .card {
                        width: 45%;
                       // background-color: $main_color;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 70px;
                        margin-bottom: 3%;
                        box-shadow: 0px 4px 10px 3px gainsboro;
                        @media (max-width: "576px") {
                            width: 100%;
                        }
                        i {
                            font-size: 25px;
                             background:linear-gradient(to right, #EB5E7B, #BC498E);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
                        a {
                            color: black;
                            margin-top: 2%;
                            padding: 0% 5%;
                            word-break: break-word;
                            font-size: 11px;
                            font-weight:500;
                        }
                    }
                }
            }
            .vcard__services {
                @include card_products_services("service");
               // background-color: $main_color;
            }
            .vcard__products {
                @include card_products_services("product");
                .services {
                    .service {
                    //    .service_icon {
                      //      img {
                              //  border-radius: 20px;
                        //    }
                        //}
                        .service_price {
                            p {
                                color: #E95D7C;
                                text-align: center;
                                font-size: 40px;
                                display: flex;
                                justify-content: center;
                                .currency {
                                    font-size: 20px;
                                    margin-top: 3%;
                                    font-weight: 400;
                                }
                                .price {
                                    font-weight: bold;
                                    font-family: $number_font;
                                }
                            }
                        }
                    }
                }
            }
            .vcard__qr_code {
                padding: 5% 2%;
                .title_qr_code{
                    font-size: 40px;
                    text-align: center;
                    margin-bottom: 5%;
                    font-weight: bold;
                     margin-bottom: 9%;
                }
              .boxShadow {
                    box-shadow: 6px 6px 7px 0px #EC5D7B;
                    margin: 5% 5%;
                    padding: 1% 1%;
                    border-radius: 20px;
                    background: white;
                    .contents {
                      /*  display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        flex-wrap: wrap; */
                        padding: 6% 0%;
                        border: 3px solid #BC498E;
                        border-radius: 20px;
                        padding: 5% 2%;
                        @media (max-width: "576px") {
                                width: 100%;
                             /*   margin-top: 15%;  */
                            }
                        .contentimg{
                             display: flex;
                             justify-content: center;   
                             margin-top : -14%; 
                             @media (max-width: "576px") {
                                margin-top : -18%;
                             /*   margin-top: 15%;  */
                            }
                             img {
                                width: 80px;
                                height: 80px;
                                object-fit: cover;
                                box-shadow: 0 0 0 6px white, 0 0 0 8px #BC498E,
                            }
                        }
                        .content {
                            display: flex;
                            justify-content: center;  
                            margin-top: 5%;  
                        }
                    }
                }
            }
            .vcard__working_hours {
                h4 {
                   font-size: 35px;
                    text-align: left;
                    background: linear-gradient(to right, #BC498E, #EB5E7B);
                    color: white;
                    padding: 1.5% 2%;
                    margin: 4% 0%;
                    width: 58%;
                    border-bottom-right-radius: 63px;
                    @media (max-width: "576px") {
                                font-size: 25px;
                                width: 92%;
                                padding: 3% 3%;
                                margin: 9% 0%;
                        }
                }
                .contents {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    border : 1px solid white;
                    border-radius : 6px;
                    box-shadow: 0px 4px 10px 3px gainsboro;
                    padding: 2% 0%;
                    p {
                        width: 100%;
                        color: #181818;            
                        display: flex;
                        justify-content: space-between;
                        text-align: center;
                         @media (max-width: "576px") {
                            font-size: small;
                        }
                        .day {
                            font-weight: bold;
                            width: 40%;
                        }
                        .dot {
                            width: 10%;
                        }
                        .hour {
                            width: 50%;
                        }
                    }
                }
            }
            .vcard__catalogue {
                h4 {
                    font-size: 40px;
                    text-align: center;
                    margin-bottom: 5%;
                }
                .catalgueListBtn {
                    a {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        button {
                            width: 40%;
                            background:linear-gradient(to right, #EB5E7B, #BC498E);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            font-weight: 500;
                            @media (max-width: "576px") {
                                width:72%;
                        }
                        }
                    }
                }
                .contents {
                    .content {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        position: relative;
                        border: 2px solid #bfc1c1;
                        margin: 5% 35%;
                        @media (max-width: "576px") {
                            margin: 5% 10%;
                        }
                        padding: 3%;
                        border-radius: 20px;
                        p {
                            font-weight: bold;
                            width: 100%;
                            text-align: center;
                        }
                        i {
                            font-size: 40px;
                            cursor: pointer;
                            transition: color .3s ease-in-out;
                            &:hover {
                                color: $main_color;
                            }
                        }
                    }
                }
            }
            .vcard__contact {
                h4 {
                    font-size: 35px;
                    text-align: left;
                    background: linear-gradient(to right, #BC498E, #EB5E7B);
                    color: white;
                    padding: 1.5% 2%;
                    margin: 4% 0%;
                    width: 44%;
                    border-bottom-right-radius: 63px;
                    @media (max-width: "576px") {
                                font-size: 25px;
                                width: 65%;
                                padding: 3% 3%;
                                margin: 9% 0%;
                        }
                }
                .formContents {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .form-group {
                        width: 100%;
                    }
                    .btnList {
                        display: flex;
                        justify-content: space-around;
                        width: 100%;
                        flex-wrap: wrap;
                        button {
                            width: 40%;
                            background: linear-gradient(to right, #EB5E7B, #BC498E);
                            color: white;
                            @media (max-width: "576px") {
                                width: 100%;
                            }
                            &:hover{
                            background: linear-gradient(to right, #BC498E, #EB5E7B);
                            }
                        }
                    }
                }
            }
            .copyright {
                position: relative;
                .line {
                    background-color: #bfc1c1;
                    width: 100%;
                    height: 2px;
                    position: absolute;
                    top: 0;
                }
                p {
                    text-align: center;
                    color: #bfc1c1;
                }
            }
        }
    }
</style>
